module.exports = __webpack_public_path__ + "static/media/path4.43994fd6.png";